export const TABS = {
  BASIC: 'basic',
  INFO: 'info',
  DELIVERY: 'delivery',
  REVIEW: 'review',
  INQUIRY: 'inquiry',
} as const;

export const TABS_LABELS = {
  [TABS.BASIC]: '답례품 소개',
  [TABS.INFO]: '상세 정보',
  [TABS.DELIVERY]: '배송 안내',
  [TABS.REVIEW]: '후기',
  [TABS.INQUIRY]: '문의',
} as const;

// 실제 배송기간 값은 사업 담당자 확정 대기 중(WEL-5374 H1). 확정되면 이 상수만 고친다
export const DELIVERY_PERIOD_LABEL = '3~7일 예상';
export const DELIVERY_PERIOD_DESCRIPTION =
  '답례품 출고 후 영업일 기준 3~7일 이내 수령이 가능하며 도서 산간 지역이거나 택배사의 물량이 많은 경우 조금 더 소요될 수 있습니다.';
